import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Hash } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const API = window.__BACKEND_URL__;

const describe = (a) => {
  if (a.action === 'settings') {
    return (a.changes || []).map((c) => `${c.label}: ${c.old ?? '—'} → ${c.new ?? '—'}`).join(' · ') || 'Numbering settings saved';
  }
  return `${a.old || '(none)'} → ${a.new}`;
};

// Admin → Audit Log → Invoice numbering: manual renumbers + numbering-settings changes.
export const InvoiceNumberingAuditCard = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/invoice-number-audit`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, params: { limit: 200 } })
      .then((r) => setRows(r.data.items || []))
      .catch(() => setRows([]));
  }, []);
  return (
    <Card data-testid="invoice-numbering-audit-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><Hash className="w-4 h-4 text-blue-500" /> Invoice numbering</CardTitle>
        <p className="text-xs text-slate-500">Who changed an invoice number (job or Daily Site Invoice) or the numbering settings, when, and why.</p>
      </CardHeader>
      <CardContent>
        {rows === null ? <p className="text-sm text-slate-500">Loading…</p>
          : rows.length === 0 ? <p className="text-sm text-slate-500 py-4 text-center" data-testid="invoice-numbering-audit-empty">No invoice numbers or numbering settings have been changed.</p>
          : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="invoice-numbering-audit-table">
                <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-500">
                  <th className="py-1.5 pr-3">When</th><th className="py-1.5 pr-3">By</th><th className="py-1.5 pr-3">What</th><th className="py-1.5 pr-3">Change</th><th className="py-1.5">Reason</th>
                </tr></thead>
                <tbody>
                  {rows.map((a) => (
                    <tr key={a.id} className="border-t border-slate-200 dark:border-slate-700" data-testid={`invoice-numbering-audit-${a.id}`}>
                      <td className="py-1.5 pr-3 whitespace-nowrap">{new Date(a.created_at).toLocaleString()}</td>
                      <td className="py-1.5 pr-3">{a.actor_name || a.actor_email || '—'}</td>
                      <td className="py-1.5 pr-3">
                        <span className="text-[10px] uppercase tracking-wide mr-1.5 px-1.5 py-0.5 rounded bg-slate-200 dark:bg-slate-700">{a.action === 'settings' ? 'Settings' : a.kind === 'daily' ? 'Daily invoice' : 'Job invoice'}</span>
                        {a.ref_label || ''}
                      </td>
                      <td className="py-1.5 pr-3 font-mono">{describe(a)}</td>
                      <td className="py-1.5 text-slate-500">{a.reason || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </CardContent>
    </Card>
  );
};
